import { useDailyQuota } from "@/modules/DailyQuota/hooks/useDailyQuota";

const useAdsLogic = () => {
    const { userType } = useDailyQuota();
    const shouldShowAds = userType === "free";
    return { shouldShowAds };
};
export default useAdsLogic;
